"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reference_resolver_1 = __importDefault(require("./reference-resolver"));
var isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
exports.default = reference_resolver_1.default(isomorphic_fetch_1.default, {
    access: function (a, b, cb) { return cb(new Error("cant resolve file refs in a browser... yet")); },
    readFile: function (a, b, cb) { return cb(); },
    constants: { F_OK: 0, R_OK: 0 } //tslint:disable-line
});
